import type { Artist, Rating } from './types.ts';

const artistOrder = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

/** Browsing never requires a rating. Only explicit/imported ratings enter My ratings. */
export function browseLineup(
  artists: readonly Artist[],
  ratings: readonly Rating[],
  userId: string,
  query = '',
  onlyMyRatings = false,
): { artist: Artist; rating: Rating | undefined }[] {
  const ownRatings = new Map(ratings.filter((rating) => rating.userId === userId)
    .map((rating) => [rating.artistId, rating]));
  const search = query.trim().toLocaleLowerCase('en');
  return artists.map((artist) => ({ artist, rating: ownRatings.get(artist.id) }))
    .filter(({ artist, rating }) => artist.name.toLocaleLowerCase('en').includes(search)
      && (!onlyMyRatings || rating?.source === 'manual' || rating?.source === 'imported'))
    .sort((a, b) => artistOrder.compare(a.artist.name, b.artist.name)
      || a.artist.id.localeCompare(b.artist.id, 'en'));
}
